@if (initialized) {
  <div>
    @if (!lab.id) {
      <h1>Add Lab</h1>
    }
    @if (lab.id) {
      <h1>Update lab "{{lab.name}}"</h1>
    }
  </div>
  <form [formGroup]="inputForm">
    <div class="form-inputs">
      <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput type="text" autocomplete="off" formControlName="name"
          [errorStateMatcher]="matcher" />
        @if (inputForm.controls.name.hasError('required')) {
          <mat-error>
            This field is <strong>required</strong>
          </mat-error>
        }
        @if (inputForm.controls.name.hasError('error')) {
          <mat-error>{{inputForm.controls.name.errors.error}}</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Phone</mat-label>
        <input matInput type="text" autocomplete="off" formControlName="phone"
          [errorStateMatcher]="matcher" />
        @if (inputForm.controls.phone.hasError('required')) {
          <mat-error>
            This field is <strong>required</strong>
          </mat-error>
        }
        @if (inputForm.controls.phone.hasError('error')) {
          <mat-error>{{inputForm.controls.phone.errors.error}}</mat-error>
        }
      </mat-form-field>
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput type="text" autocomplete="off" formControlName="email"
          [errorStateMatcher]="matcher" />
        @if (inputForm.controls.email.hasError('required')) {
          <mat-error>
            This field is <strong>required</strong>
          </mat-error>
        }
        @if (inputForm.controls.email.hasError('error')) {
          <mat-error>{{inputForm.controls.email.errors.error}}</mat-error>
        }
      </mat-form-field>
    </div>
    <div class="form-actions">
      @if (!lab.id) {
        <button mat-stroked-button color="primary"
        type="button" [disabled]="!inputForm.valid" (click)="onSubmit()">Create</button>
      }
      @if (lab.id) {
        <button mat-stroked-button color="primary"
        type="button" [disabled]="!inputForm.valid" (click)="onSubmit()">Update</button>
      }
      <button mat-stroked-button color="accent" (click)="onClose(false)" disableRipple>Cancel</button>
    </div>
  </form>
}
